import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '21',
  viewBox: '0 0 24 21',
  fill: '#FFF'
}, [
  h('path', {
    d: 'M18.5 21H.5c-.3 0-.5-.2-.5-.5 0-.1 0-3.4.5-4.9.4-1.2 2.7-2.1 5.3-3 .4-.1.8-.3 1.2-.4v-1.8C6.2 9.9 5 8.9 5 7V5s0-.1-.1-.2c-.2-.8-.5-2.2.2-3 .3-.3.7-.4 1.2-.4C6.9.4 8.6 0 9.9 0c1.5 0 3.5.5 3.8 1.8.3 1.1-.2 2.2-.5 2.9.4.3.6.7.6 1.3 0 .7-.3 1.2-.8 1.4-.1 1.7-.7 2.5-1 2.8v1.9c.5.2.9.3 1.3.5 2.7 1 4.8 1.7 5.2 3 .5 1.5.5 4.8.5 4.9 0 .3-.2.5-.5.5zM1 20h17c0-1-.1-3.1-.4-4.1-.3-.8-2.4-1.6-4.6-2.3-.5-.2-1.1-.4-1.7-.6-.2-.1-.3-.3-.3-.5V10c0-.2.1-.3.2-.4 0-.1.8-.6.8-2.6 0-.3.2-.5.5-.5.2 0 .2-.3.2-.5s-.1-.5-.2-.5c-.3 0-.5-.3-.5-.5s.1-.3.2-.6c.3-.5.7-1.5.5-2.3-.1-.6-1.4-1-2.8-1s-2.7.5-2.8 1c-.1.2-.3.4-.6.4-.2-.1-.5-.1-.7 0-.3.3 0 1.6.1 2 .1.2.1.3.1.5v2c0 2 1.6 2.5 1.7 2.5.2.1.3.2.3.5v2.5c0 .2-.1.4-.3.5-.5.2-1 .4-1.6.6-2 .7-4.4 1.6-4.7 2.4-.3.9-.4 3-.4 4z'
  }),
  h('path', {
    d: 'M23.5 21H21c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c0-1-.1-3.1-.4-4.1-.3-.8-2.4-2-6.2-3.4-.3-.1-.4-.3-.4-.5v-1.5c0-.2.1-.3.2-.4 0 0 .8-.6.8-2.6 0-.3.2-.5.5-.5 0 0 .1 0 .1-.1.1-.1.1-.3.1-.4 0-.2-.1-.5-.2-.5-.3 0-.5-.3-.5-.5s.1-.3.2-.6c.3-.6.8-1.6.6-2.4-.1-.3-.6-.8-1.3-1.1-.4-.2-1-.3-1.6.1-.2.2-.5.1-.7-.1s-.1-.5.1-.7C15.1.1 16 0 16.9.4c.9.4 1.7 1.1 1.9 1.8.3 1.1-.3 2.3-.6 3 .4.3.6.7.6 1.3 0 .4-.1.7-.3 1-.1.2-.3.3-.5.4-.1 1.7-.7 2.5-1 2.8v.9c4.2 1.6 6.1 2.8 6.5 3.9.5 1.5.5 4.8.5 4.9 0 .4-.2.6-.5.6z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-organization-users.es6.js